export default __webpack_public_path__ + "static/media/Host.290aa1ec.svg";